module.exports = __webpack_public_path__ + "static/media/group.09ccb366.png";